import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell
} from '@material-ui/core'

/**
 * SwimlanesEditor
 */
export const SwimlanesEditor = props => {
  const swimlanes = props.swimlanes

  const getSwimlane = id => swimlanes.find(s => s.id === id)

  const onFieldChange =  (laneId, fieldName, newValue) => {
    const originalSwimlane = getSwimlane(laneId)
    const updatedLane = { ...originalSwimlane, [fieldName]: newValue }
    const updatedLanes = swimlanes.map(swimlane => swimlane.id === laneId ? updatedLane : swimlane)
    props.onChange(updatedLanes)
  }

  const onMappingChange = (laneId, fieldName, newValue) => {
    const mapping = getSwimlane(laneId).mapping
    let updatedMapping = { ...mapping }

    if (fieldName === 'onHold') {
      const setToValue = newValue ? undefined : mapping.startPercent
      updatedMapping.setPercentCompleteTo = setToValue
      updatedMapping.onHold = newValue
    } else {
      updatedMapping[fieldName] = parseInt(newValue, 10)

      const setPercentInRange = updatedMapping.startPercent <= updatedMapping.setPercentCompleteTo
        && updatedMapping.setPercentCompleteTo <= updatedMapping.endPercent
      if (!setPercentInRange) {
        updatedMapping.setPercentCompleteTo = updatedMapping[fieldName]
      }
    }

    if (updatedMapping.startPercent === 0 && updatedMapping.endPercent !== 0 && updatedMapping.setPercentCompleteTo === 0) {
      updatedMapping.setPercentCompleteTo = 1
    }

    onFieldChange(laneId, 'mapping', updatedMapping)
  }

  const deleteLane = (laneId) => {
    const updatedLanes = swimlanes.filter(s => s.id !== laneId)
    props.onChange(updatedLanes)
  }

  const inputWidth = 80
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell compact>Name</TableCell>
          <TableCell compact style={{ width: `${inputWidth}px` }}>Start %</TableCell>
          <TableCell compact style={{ width: `${inputWidth}px` }}>End %</TableCell>
          <TableCell compact style={{ width: `${inputWidth}px` }}>Set %</TableCell>
          <TableCell compact style={{ width: `${inputWidth}px` }}>On Hold</TableCell>
          <TableCell compact style={{ width: `${inputWidth}px` }}>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {swimlanes.map((s, i) => (
          <TableRow key={`${s.id}`}>
            <TableCell compact>
              <TextField
                id={`header_${s.id}_field`}
                onChange={event => onFieldChange(s.id, 'name', event.target.value)}
                value={s.name}
                style={{ width: '200px' }}
                />
            </TableCell>
            <TableCell compact style={{ width: `${inputWidth}px` }}>
              <TextField
                id={`start_${s.id}_field`}
                value={s.mapping.onHold ? 0 : s.mapping.startPercent}
                type='number'
                min={0}
                max={100}
                style={{width: `${inputWidth}px`}}
                disabled={s.mapping.onHold}
                onChange={event => onMappingChange(s.id, 'startPercent', event.target.value)}
                />
            </TableCell>
            <TableCell compact style={{ width: `${inputWidth}px` }}>
              <TextField
                id={`end_${s.id}_field`}
                value={s.mapping.onHold ? 100 : s.mapping.endPercent}
                type='number'
                min={0}
                max={100}
                style={{width: `${inputWidth}px`}}
                disabled={s.mapping.onHold}
                onChange={event => onMappingChange(s.id, 'endPercent', event.target.value)}
                />
            </TableCell>
            <TableCell compact style={{ width: `${inputWidth}px` }}>
              <TextField
                id={`set_${s.id}_field`}
                value={s.mapping.onHold ? '' : s.mapping.setPercentCompleteTo}
                type='number'
                min={s.mapping.startPercent}
                max={s.mapping.endPercent}
                style={{ width: `${inputWidth}px` }}
                disabled={s.mapping.onHold}
                onChange={event => onMappingChange(s.id, 'setPercentCompleteTo', event.target.value)}
                />
            </TableCell>
            <TableCell compact style={{ width: `${inputWidth}px` }}>
              <Checkbox
                id={`hold_${s.id}_field`}
                checked={s.mapping.onHold}
                onChange={(event, checked) => onMappingChange(s.id, 'onHold', checked)} />
            </TableCell>
            <TableCell disablePadding style={{ width: `${inputWidth}px` }}>
              <Button onClick={() => deleteLane(s.id)}>Delete</Button>
            </TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell compact>
            <Button
              fab
              style={{ width: '35px', height: '35px', margin: '10px' }}
              color='primary'
              onClick={props.addLane}>
              <AddIcon />
            </Button>
          </TableCell>
          <TableCell disablePadding />
          <TableCell disablePadding />
          <TableCell disablePadding />
          <TableCell disablePadding />
        </TableRow>
      </TableBody>
    </Table>
  )
}

SwimlanesEditor.propTypes = {
  swimlanes: PropTypes.array.isRequired,
  addLane: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default SwimlanesEditor;



// WEBPACK FOOTER //
// ./src/routes/BoardDefsEditor/components/SwimlanesEditor.js